import {
  ITEM_LIST_REQUEST,
  ITEM_LIST_SUCCESS,
  ITEM_LIST_FAIL,
  ITEM_LIST_RESET,
  ITEM_ALL_REQUEST,
  ITEM_ALL_SUCCESS,
  ITEM_ALL_FAIL,
  ITEM_ADD_REQUEST,
  ITEM_ADD_SUCCESS,
  ITEM_ADD_FAIL,
  ITEM_DELETE_REQUEST,
  ITEM_DELETE_SUCCESS,
  ITEM_DELETE_FAIL
} from '../constants/itemConstants'

export const itemListReducer = (state = { items: [] }, action) => {
  switch (action.type) {
    case ITEM_LIST_REQUEST:
      return { loading: true, ...state }
    case ITEM_LIST_SUCCESS:
      return {
        loading: false,
        error: false,
        items: action.payload.items,
        pagesitem: action.payload.pagesitem,
        pageitem: action.payload.pageitem,
        count: action.payload.count
      }
    case ITEM_LIST_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const itemListAllReducer = (state = { itemsall: [] }, action) => {
  switch (action.type) {
    case ITEM_ALL_REQUEST:
      return { loading: true, ...state }

    case ITEM_ALL_SUCCESS:
      return {
        loading: false,
        error: false,
        itemsall: action.payload.itemsall
      }

    case ITEM_ALL_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const itemAddReducer = (state = {}, action) => {
  switch (action.type) {
    case ITEM_ADD_REQUEST:
      return { loading: true }
    case ITEM_ADD_SUCCESS:
      return { loading: false, success: true }
    case ITEM_ADD_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const itemDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case ITEM_DELETE_REQUEST:
      return { loading: true }
    case ITEM_DELETE_SUCCESS:
      return { loading: false, success: true }
    case ITEM_DELETE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const itemResetReducer = (state = {}, action) => {
  switch (action.type) {
    case ITEM_LIST_RESET:
      return {}
    default:
      return state
  }
}
